/**
 * Enum representing different outbox types.
 */
export enum OutboxTypeEnum {
	/**
	 * Represents a notification
	 */
	NOTIFICATION = 'notification',

	/**
	 * Represents a reminder
	 */
	REMINDER = 'reminder',
}
